// extracted by mini-css-extract-plugin
export default {"vip-ctn":"ModalVip_vip-ctn__3h9Mc","title":"ModalVip_title__cM6W3","describe":"ModalVip_describe__lIaHQ","btn":"ModalVip_btn__2zKqm","close":"ModalVip_close__6+xCP"};